import { Box, Button, Grid, Typography, Stack } from "@mui/material";
import { motion } from "framer-motion";
import service from "../../../images/songjukti_im/service.jpeg";
import working from "../../../images/songjukti_im/working.jpg";
import { heading, bodyText, buttonSx } from "../../../store/presetsNew";
import { tokens } from "../../../store/tokens";

const StartEarning = () => {
  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, ${tokens.color.surfaceAlt} 0%, #EAF3FD 100%)`,
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4, md: 10 },
      }}
    >
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        {/* Left Image */}
        <Grid item xs={12} md={4} order={{ xs: 2, md: 1 }}>
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
            sx={{
              position: "relative",
              width: "100%",
              justifyContent: "center",
              display: { xs: "none", md: "flex" },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: 180,
                height: 180,
                bgcolor: tokens.color.tealLight,
                borderRadius: "50%",
                top: 20,
                left: 30,
                zIndex: 0,
              }}
            />
            <Box
              sx={{
                position: "absolute",
                width: 100,
                height: 100,
                bgcolor: tokens.color.infoBg,
                borderRadius: "50%",
                bottom: 10,
                right: 40,
                zIndex: 0,
              }}
            />
            <Box
              component="img"
              src={service}
              alt="Freelancer delivering a service"
              sx={{
                width: { xs: 120, sm: 150, md: 200 },
                height: { xs: 120, sm: 150, md: 200 },
                borderRadius: "50%",
                objectFit: "cover",
                border: `4px solid ${tokens.color.surface}`,
                boxShadow: tokens.shadow.md,
                zIndex: 1,
                position: "relative",
                transition: "transform 0.4s ease",
                "&:hover": { transform: "scale(1.05)" },
              }}
            />
          </Box>
        </Grid>

        {/* Center Content */}
        <Grid item xs={12} md={4} order={{ xs: 1, md: 2 }}>
          <Stack
            component={motion.div}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.5 }}
            spacing={2.5}
            textAlign="center"
          >
            <Typography sx={{ ...heading("h3"), fontSize: { xs: "1.5rem", md: "1.9rem" } }}>
              Start your journey with Songjukti
            </Typography>

            <Typography sx={{ ...bodyText("body1"), fontSize: { xs: "0.9rem", md: "1rem" } }}>
              Connect with top freelancers or clients worldwide. Whether
              you're offering services or hiring talent, Songjukti empowers
              your next step — with secure, protected payments every time.
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Button
                component={motion.button}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => window.open("http://user.songjukti.com/")}
                sx={{ ...buttonSx("lg", "dark"), width: { xs: "100%", sm: "auto" } }}
              >
                I want a service
              </Button>

              <Button
                component={motion.button}
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => window.open("http://user.songjukti.com/")}
                sx={{ ...buttonSx("lg", "solid"), width: { xs: "100%", sm: "auto" } }}
              >
                I want to work
              </Button>
            </Stack>

            <Typography sx={{ ...bodyText("body2") }}>
              By continuing, you agree to our{" "}
              <Box
                component="span"
                sx={{ color: tokens.color.teal, cursor: "pointer", fontWeight: 600 }}
                onClick={() => window.open("https://songjukti.com/terms")}
              >
                Terms
              </Box>{" "}
              and{" "}
              <Box
                component="span"
                sx={{ color: tokens.color.teal, cursor: "pointer", fontWeight: 600 }}
                onClick={() => window.open("https://songjukti.com/privacypolicy")}
              >
                Privacy Policy
              </Box>
              .
            </Typography>
          </Stack>
        </Grid>

        {/* Right Image */}
        <Grid item xs={12} md={4} order={{ xs: 3 }}>
          <Box
            component={motion.div}
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.55, ease: "easeOut" }}
            sx={{
              position: "relative",
              width: "100%",
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: 180,
                height: 180,
                bgcolor: tokens.color.successBg,
                borderRadius: "50%",
                top: 25,
                right: 30,
                zIndex: 0,
              }}
            />
            <Box
              sx={{
                position: "absolute",
                width: 100,
                height: 100,
                bgcolor: tokens.color.tealLight,
                borderRadius: "50%",
                bottom: 10,
                left: 40,
                zIndex: 0,
              }}
            />
            <Box
              component="img"
              src={working}
              alt="Client reviewing project work"
              sx={{
                width: { xs: 120, sm: 150, md: 200 },
                height: { xs: 120, sm: 150, md: 200 },
                borderRadius: "50%",
                objectFit: "cover",
                border: `4px solid ${tokens.color.surface}`,
                boxShadow: tokens.shadow.md,
                zIndex: 1,
                position: "relative",
                transition: "transform 0.4s ease",
                "&:hover": { transform: "scale(1.05)" },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StartEarning;